module.exports = __webpack_public_path__ + "static/media/google-play.a8348bbc.png";